import axios from 'axios';

export default {
    namespaced: true,
    state: {
        userNotifications: null,
        loadingUserNotifications: false
    },
    mutations: {
        loadUserNotifications(state) {
            state.loadingUserNotifications = true;
        },
        resetUserNotifications(state) {
            state.userNotifications = null;
        },
        updateUserNotifications(state, data) {
            state.userNotifications = data;
            state.loadingUserNotifications = false;
        }
    },
    actions: {
        getUserNotifications({ commit }) {
            commit('resetUserNotifications');
            commit('loadUserNotifications');
            axios
                .get('/user-notifications')
                .then(result => {
                    commit('updateUserNotifications', result.data);
                })
                .catch(console.error);
        },
        postLNotificationSettings({ state }) {
            axios
                .post('/user-notifications', state.userNotifications)
                .catch(console.error);
        }
    }
};
